import { IDocument } from "config";
import { AppError } from "config/errors";
import { fetchDocumentById, fetchDocumentCategories } from "gql/queries/documents";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const getDocumentById = createAsyncThunk(
  "documents/getDocumentById",
  async (documentId: IDocument["id"], { rejectWithValue }) => {
    try {
      const { data } = await fetchDocumentById(documentId);

      return data.document;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getDocumentsCategories = createAsyncThunk(
  "documents/getCategories",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchDocumentCategories();
      return data.documentCategories;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
